import { Uteleme_service } from "../services/Uteleme.service";
import moment from "moment";
import { Loading } from "element-ui";

const title = {
    'outgoing_call': 'ค่าเฉลี่ยจำนวนครั้งการโทรออกต่อวัน',
    'sms_send': 'ค่าเฉลี่ยจำนวนครั้งการส่ง sms ต่อวัน',
    'mms_send': 'ค่าเฉลี่ยจำนวนครั้งการส่ง mms ต่อวัน',
    'download_bytes': 'ค่าเฉลี่ยการดาวน์โหลดข้อมูลต่อวัน',
    'upload_bytes': 'ค่าเฉลี่ยการอัพโหลดข้อมูลต่อวัน'
}
const yAxis = {
    'outgoing_call': '(ครั้ง/วัน)',
    'sms_send': '(ครั้ง/วัน)',
    'mms_send': '(ครั้ง/วัน)',
    'download_bytes': '(MB/วัน)',
    'upload_bytes': '(MB/วัน)'
}
const unit = {
    'outgoing_call': 'ครั้ง',
    'sms_send': 'ครั้ง',
    'mms_send': 'ครั้ง',
    'download_bytes': 'MB',
    'upload_bytes': 'MB'
}
const month_th = ['มกราคม','กุมภาพันธ์','มีนาคม','เมษายน','พฤษภาคม','มิถุนายน','กรกฎาคม','สิงหาคม','กันยายน','ตุลาคม','พฤศจิกายน','ธันวาคม']
const short_month_th = ['ม.ค.','ก.พ.','มี.ค.','เม.ย.','พ.ค.','มิ.ย.','ก.ค.','ส.ค.','ก.ย.','ต.ค.','พ.ย.','ธ.ค.']

const state = {
    prototype : {
        chart: {
            type: 'spline'
        },
        title: {
            text: '',
            margin: 50
        },
        subtitle: {
            text: ''
        },
        xAxis: {
            categories: [],
            crosshair: true,
            title: ""
        },
        yAxis: {
            min: 0,
            title: {
                text: '',
                // align: 'high',
                // offset: -100,
                // rotation: 0,
                // y: -30
            }
        },
        tooltip: {
            pointFormat: '{series.name}: <b>{point.y}</b> ครั้ง<br/><br/>',
            shared: true
        },
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0,
                dataLabels: {
                    enabled: false
              }
            }
        },
        series: [],
        legend: {},
        exporting: {
            buttons: {
              contextButton:{
                  menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS"]
              }
            }
          },
        credits: {
            enabled: false
        }
    },
    chart: {},
    displayText: false,
    displayChart: false
}

const actions = {
    
    async getUtelemeStats({ commit }, formdata) {
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        state.displayChart = false
        state.displayText = false
        let result = await Uteleme_service.getUtelemeStats(formdata)
        if(result.data.length > 0 ) {
            let data = {
                form: formdata,
                result: result.data
            }
            commit('SET_DATA', data)
            setTimeout(function(){ loadingInstance.close() }, 250);
        } else {
            state.displayText = true
            setTimeout(function(){ loadingInstance.close() }, 250);
        }
    }
}

const mutations = {
    SET_DATA(state, data){
        state.displayChart = true
        let new_chart = JSON.parse(JSON.stringify(state.prototype))
        let start = moment(data.form.date_range[0]).date() + ' ' + month_th[moment(data.form.date_range[0]).month()] + ' พ.ศ. ' +  moment(data.form.date_range[0]).add(543, 'Y').format('YYYY')
        let end = moment(data.form.date_range[1]).date() + ' ' + month_th[moment(data.form.date_range[1]).month()] + ' พ.ศ. ' +  moment(data.form.date_range[1]).add(543, 'Y').format('YYYY')
        new_chart.title.text = `รายงาน ${title[data.form.data_type]}`
        // new_chart.subtitle.text = `ระหว่างวันที่ ${start} ถึง ${end} <br/>*แหล่งที่มาของข้อมูล : แอปพลิเคชันพฤติมาตร`
        new_chart.subtitle.text = `ระหว่างวันที่ ${start} ถึง ${end}`
        new_chart.yAxis.title.text = yAxis[data.form.data_type]
        let data_list = []
        let categories = []
        for(let date = moment(data.form.date_range[0])._d; date <= moment(data.form.date_range[1])._d; date = moment(date).add(1, 'd')._d) {
            let current_data = data.result.filter(data => moment(data.created_at).format('YYYY-MM-DD') == moment(date).format('YYYY-MM-DD'))
            let temp = current_data[0] ? parseFloat(current_data[0][data.form.data_type]) : null
            categories.push(moment(date).date() + ' ' + short_month_th[moment(date).month()] + ' ' + moment(date).add(543, 'Y').format('YY'))
            if (data.form.data_type == 'download_bytes' || data.form.data_type == 'upload_bytes') {
                temp = temp != null ? temp / 1000000 : null
            }
            data_list.push(temp)
        }
        new_chart.series = [{
            name: title[data.form.data_type],
            data: data_list
        }]
        new_chart.xAxis.categories = categories
        new_chart.plotOptions = {
            column: {
                pointPadding: 0.2,
                borderWidth: 0,
                dataLabels: {
                    enabled: false,
                    format: '{point.y:.4f}'
              }
            }
        }
        new_chart.tooltip = {
            pointFormat: '{series.name}: <b>{point.y:.4f}</b> ' + unit[data.form.data_type] + '<br/><br/>',
            shared: true
        }
        new_chart.caption = {
            text: "*แหล่งที่มาของข้อมูล : แอปพลิเคชันพฤติมาตร",
            align: 'left',
            verticalAlign: 'bottom'
        }
        state.chart = new_chart
    }
}

export const UtelemeStore = {
    namespaced: true,
    state,
    actions,
    mutations
}